var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"random_box"},_vm._l((_vm.randomCode),function(item,index){return _c('span',{key:index},[_vm._v(_vm._s(item))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }